<div
    class="component-container flex-vertical-container"
    [class.border-0]="border === borderType.none"
    [class.border-all]="border === borderType.all"
    [class.border-top]="border === borderType.top"
    [class.border-bottom]="border === borderType.bottom"
    [class.border-start]="border === borderType.left"
    [class.border-end]="border === borderType.right"
    [class.border-radius]="borderRadius"
>
    @if (displayHeader) {
        <div class="card-header d-flex flex-row" [class.card-header-bordered]="!isDataGridContainer">
            <div class="align-self-center">
                <ng-content select="[title]"></ng-content>
            </div>
            <div class="ps-1 pe-1 align-self-center">
                <ng-content select="[middle]"></ng-content>
            </div>
            <div class="ms-auto align-self-center">
                <ng-content select="[icon]"></ng-content>
            </div>
        </div>
    }
    <div class="card-body p-0 standard-grid h-100 flex-grow-1">
        <ng-content select="[body]"></ng-content>
        <ng-content select="[loader]"></ng-content>
    </div>
    @if (displayFooter) {
        <div class="card-footer">
            <ng-content select="[footer]"></ng-content>
        </div>
    }
</div>
